import { render, staticRenderFns } from "./LayoutHeadingTabs.vue?vue&type=template&id=681d5d91&scoped=true&"
import script from "./LayoutHeadingTabs.vue?vue&type=script&lang=js&"
export * from "./LayoutHeadingTabs.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHeadingTabs.vue?vue&type=style&index=0&id=681d5d91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d5d91",
  null
  
)

export default component.exports